<div class="modal-header">
  <h4 class="modal-title">
    {{ hasBeenEmailed ? 'Resend Payment Request Email' : 'Send Payment Request Email' }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form (ngSubmit)="onSubmit()" #form="ngForm">

    <div class="form-group">
      <label for="resend-recipient-select">Recipient</label>
      <select id="resend-recipient-select" name="recipient_option"
              class="custom-select"
              [(ngModel)]="recipientOption">
        <option [value]="RecipientOption.bookingCustomer">
          Booking Customer Email: {{ bookingCustomerEmail }}
        </option>
        <option [value]="RecipientOption.manual">
          Other Email Address
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="recipientOption === RecipientOption.manual">
      <label for="resend-manual-email">Email Address</label>
      <input id="resend-manual-email" name="manual_email" type="email" required
             class="form-control"
             [(ngModel)]="manualEmail">
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="modal-footer mt-3 px-0 pb-0">
      <button type="button" class="btn btn-secondary"
              [disabled]="loading"
              (click)="activeModal.dismiss()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary"
              [disabled]="loading || !form.valid"
              [class.disabled]="loading || !form.valid">
        {{ loading ? 'Sending...' : 'Send Email' }}
      </button>
    </div>
  </form>
</div>
